// removed by extract-text-webpack-plugin
module.exports = {"DrawerToggle":"DrawerToggle__-loca-__1eThf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/DrawerToggle/DrawerToggle.css
// module id = 167
// module chunks = 0